import get from 'lodash/get'
import { filters } from '@/enum/widgetTemplateConfigs'
import { getEntityList, getRemoteEntityList } from '@/composables/globalData/useEntitiesData'

export async function getOptionsList (ParameterName) {
    const templateConfig = getTemplateConfig(ParameterName)
    const EntitiesListKey = get(templateConfig, 'EntitiesListKey')

    let options

    if (templateConfig?.remote && templateConfig.EndPoint) {
        options = await getRemoteEntityList(templateConfig.EndPoint)
    } else {
        options = getEntityList(EntitiesListKey)
    }

    // console.log({
    //     options,
    //     templateConfig
    // })
    if (!options) {
        return []
    }

    options = options.filter(object => {
        if (!(templateConfig.value in object) || !(templateConfig.label in object)) {
            return false
        }
        return Object.keys(object).every(field => {
            if (!object[field] && object[field] !== 0) {
                return false
            }
            return object
        })
    })

    return options
}

export function getTemplateConfig (ParameterName) {
    return filters[ParameterName?.toLowerCase()]
}
